<template>
  <path fill-rule="evenodd"
        d="M21.333 26a.658.658 0 0 1-.666.667h-9.334a.658.658 0 0 1-.666-.667v-3.333c0-.375.291-.667.666-.667h2v-6.667h-2a.658.658 0 0 1-.666-.666v-3.334c0-.375.291-.666.666-.666H18c.375 0 .667.291.667.666V22h2c.375 0 .666.292.666.667V26zM18.667 7.333A.658.658 0 0 1 18 8h-4a.658.658 0 0 1-.667-.667V4c0-.375.292-.667.667-.667h4c.375 0 .667.292.667.667v3.333zM32 16c0-8.833-7.167-16-16-16S0 7.167 0 16s7.167 16 16 16 16-7.167 16-16z"/>
</template>

<script>
export default {
    name: 'infoTooltipIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
